/* AFIQ redesign: Team & bulk orders (sections/afiq-team-*.liquid). Port of site/team-orders.html.
   Several team sections load this file; it runs once and wires whichever parts are on the page:
   trust strip, ladder strip, quantity grid + summary (AFIQ_UI.priceDecks / addToCart) and the quote form tracking. */
(function () {
  'use strict';
  if (window.__afiqTeamInit || !window.AFIQ_UI || !window.AFIQ) return;
  window.__afiqTeamInit = true;
  var U = window.AFIQ_UI, P = U.P, $ = U.$, esc = U.esc, I = U.I, DECKS = U.DECKS;

  var trust = document.querySelector('[data-afiq-trust]');
  if (trust) trust.outerHTML = U.trust();

  /* Ladder strip: single-deck price, then every tier (unit price on Volume 1's price) */
  var strip = document.querySelector('[data-afiq-lstrip]');
  if (strip && P.v1) {
    var top = AFIQ.LADDER[AFIQ.LADDER.length - 1];
    strip.innerHTML = '<div><b>1</b><span>deck</span><em>' + $(P.v1.price) + '</em></div>' +
      AFIQ.LADDER.map(function (t, i) {
        var nx = AFIQ.LADDER[i + 1], range = nx ? (nx.min - 1 > t.min ? '–' + (nx.min - 1) : '') : '+';
        return '<div class="' + (t === top ? 'hl' : '') + '"><b>' + t.min + range + '</b><span>decks · ' + t.pct + '% off</span><em>' + $(AFIQ.unitCents(t.min, P.v1.price)) + ' each</em></div>';
      }).join('');
  }

  /* Quantity grid + order summary */
  var grid = document.querySelector('[data-afiq-team-grid]');
  if (grid) {
    var el = function (k) { return grid.querySelector('[data-el="' + k + '"]'); };
    var n = {};
    var list = function () { var out = []; DECKS.forEach(function (d) { for (var i = 0; i < (n[d] || 0); i++) out.push(d); }); return out; };
    var label = function (x) { return x.kind === 'volume' ? x.label + ': ' + x.title : x.title; };
    var render = function () {
      var ids = list(), q = U.priceDecks(ids), tot = ids.length, nx = AFIQ.nextTier(q.ladderN);
      el('qgrid').innerHTML = '<div class="qrow head" aria-hidden="true"><span></span><span>Deck</span><span>Unit price</span><span>Quantity</span><span style="text-align:right">Line total</span></div>' +
        DECKS.map(function (d) {
          var x = P[d], c = n[d] || 0, u = x.ladder ? AFIQ.unitCents(q.ladderN, x.price) : x.price;
          return '<div class="qrow"><img src="' + esc(x.cutout_sm || x.cutout) + '" alt="" width="120" height="176" loading="lazy">' +
            '<div><b>' + esc(label(x)) + '</b><small>' + esc(x.tag) + (x.ladder ? '' : ' · everyday price') + '</small></div>' +
            '<span class="unit">' + $(u) + (u < x.price ? '<s>' + $(x.price) + '</s>' : '') + '</span>' +
            '<div><div class="stepper"><button type="button" data-step="' + d + '" data-d="-1" aria-label="Remove one ' + esc(x.label) + '">' + I.minus + '</button><output aria-label="' + esc(x.label) + ' quantity">' + c + '</output><button type="button" data-step="' + d + '" data-d="1" aria-label="Add one ' + esc(x.label) + '">' + I.plus + '</button></div>' +
            '<button type="button" class="q10" data-step="' + d + '" data-d="10" aria-label="Add 10 ' + esc(x.label) + '">+10</button></div>' +
            '<span class="line">' + (c ? $(u * c) : '—') + '</span></div>';
        }).join('');
      var via = q.bundle ? q.bundle.title + (q.copies > 1 ? ' × ' + q.copies : '') + ' price' + (q.rest.some(function (d) { return P[d].ladder; }) ? ' + team discount' : '')
        : 'Team discount' + (q.pct ? ' (' + q.pct + '%)' : '');
      el('sum').innerHTML = '<h3>Order summary</h3>' +
        (tot ? '<div class="sum-stack">' + U.stack(DECKS.filter(function (d) { return n[d]; }).slice(0, 6)) + '</div>' : '<div class="sum-empty">Add decks to see your team price.</div>') +
        '<div class="rows"><div><span>Total decks</span><b>' + tot + '</b></div><div><span>Subtotal</span><b>' + $(q.full) + '</b></div>' +
        '<div class="grn"><span>' + esc(via) + '</span><b>−' + $(q.save) + '</b></div>' +
        '<div><span>Shipping</span><b>Free</b></div>' +
        '<div class="tot"><span>Total</span><span>' + $(q.total) + '</span></div></div>' +
        '<button type="button" class="btn btn-red" data-add ' + (tot ? '' : 'disabled') + '>' + I.cart + (tot ? 'Add ' + tot + ' deck' + (tot > 1 ? 's' : '') + ' · ' + $(q.total) : 'Add to cart') + '</button>' +
        '<p class="sum-n">' + (nx ? (nx.min - q.ladderN) + ' more deck' + (nx.min - q.ladderN > 1 ? 's' : '') + ' gets every deck ' + nx.pct + '% off.' : 'Team pricing unlocked: ' + AFIQ.tier(q.ladderN).pct + '% off every deck.') + '</p>';
    };
    grid.addEventListener('click', function (e) {
      var t = e.target.closest('[data-step],[data-add]'); if (!t) return;
      if (t.hasAttribute('data-add')) { var ids = list(); if (ids.length) U.addToCart(U.cartItems(ids, 'team-orders'), 'team-orders', t); return; }
      var d = t.dataset.step; n[d] = Math.max(0, Math.min(500, (n[d] || 0) + +t.dataset.d));
      var sel = '[data-step="' + d + '"][data-d="' + t.dataset.d + '"]';
      render();
      var again = grid.querySelector(sel); if (again) again.focus();
    });
    render();
  }

  /* Quote form: a real Shopify contact form. Track the submit, then let it post. */
  var quote = document.querySelector('[data-afiq-team-quote] form');
  if (quote) {
    quote.addEventListener('submit', function () {
      var prog = quote.querySelector('[name="contact[Program]"]:checked'), decks = quote.querySelector('[name="contact[Decks]"]');
      U.track('afiq_team_quote', { program: prog ? prog.value : '', decks: decks && decks.value ? +decks.value : 0 });
    });
    if (/[?&]contact_posted=true/.test(location.search) && quote.querySelector('.formwrap.sent')) {
      var sec = document.getElementById('quote'); if (sec) sec.scrollIntoView();
    }
  }
})();
